var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('router-view'),_c('Footer'),_c('div',{staticClass:"top-btn",on:{"click":_vm.scrollToTop}},[_vm._v("↑"),_c('br'),_vm._v("Top")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }